import software from "./software.json";
export default software;
